/* screens/ItineraryList.jsx */
import "./Profile.css";
import BackBtn from "./Shared/BackBtn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion, easeOut } from "framer-motion";

export default function ItineraryList(){
  const { user } = useSelector(s=>s.auth);
  const itins = user?.itineraries||[];
  const nav = useNavigate();

  return(
    <motion.div className="pf-wrap" initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.3,
                            ease: easeOut,
                        }}>
      <BackBtn/>
      <div className="pf-it-head">
        <h2 style={{margin:0,color:"#37474F"}}>Travel itineraries</h2>
        <button className="pf-add" onClick={()=>nav("add")}>Add</button>
      </div>

      {itins.map((it,i)=>(
        <div key={i} className="pf-it-row" onClick={()=>nav(i.toString())}>
          <CalendarMonthIcon sx={{color:"#F5A623"}}/>
          {new Date(it.from).toLocaleDateString()} &nbsp;–&nbsp;
          {new Date(it.to).toLocaleDateString()}
          <span>{it.days?.length||0} activities</span>
        </div>
      ))}
    </motion.div>
  );
}
